import { render, staticRenderFns } from "./Rememberpassword.vue?vue&type=template&id=4204ce10&scoped=true&"
import script from "./Rememberpassword.vue?vue&type=script&lang=js&"
export * from "./Rememberpassword.vue?vue&type=script&lang=js&"
import style0 from "./Rememberpassword.vue?vue&type=style&index=0&id=4204ce10&scoped=true&lang=css&"
import style1 from "./Rememberpassword.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204ce10",
  null
  
)

export default component.exports